'use strict';

var _ = require('lodash');

exports.getRandom = function (arr, n) {
    var result = new Array(n),
        len = arr.length,
        taken = new Array(len);
    if (n > len) {
        throw new RangeError('getRandom: more elements taken than available');
    }
    while (n--) {
        var x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len;
    }
    return result;
};


exports.generateRandomInteger = function (min, max) {
    if (_.isNaN(min) || _.isNaN(max)) {
        return 0;
    }

    return Math.floor(Math.random() * (max - min + 1)) + min;
};
